<template>
  <div :class="togglerClass" v-on="$listeners">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from '@nuxtjs/composition-api';

type DropdownTogglerProps = {
  disabled?: boolean;
};

const props = withDefaults(defineProps<DropdownTogglerProps>(), {
  disabled: false,
});

const togglerClass = computed(() => ({
  'dropdown-toggler': true,
  'dropdown-toggler--disabled': props.disabled,
}));
</script>

<style scoped lang="scss">
.dropdown-toggler {
  cursor: pointer;

  &--disabled {
    cursor: not-allowed;
  }
}
</style>
